import ValueExpression, {
  TargetValueType,
} from '@legacy-modules/valueexpressions/models/valueexpressions/ValueExpression';

import { PositiveDirection } from '@legacy-modules/metrics2/models/entities/PositiveDirection';
import { getDefinitionByName } from '@legacy-modules/common/util/kpiDefinitions';

export default new ValueExpression({
  identifier: 'ps_abgaben_avg',
  label: 'Ø PS Abgaben',
  valueFormat: '-#.###.##0,0',
  positiveDirection: PositiveDirection.custom,
  definition: getDefinitionByName('PS Abgaben'),
  targetValueType: TargetValueType.QUOTE,
  decimalPlaces: 2,
});
